import useTranslation from 'next-translate/useTranslation'

import Logo from '@/atoms/Logo'

function FooterTopSection() {
  const { t } = useTranslation('global')

  return (
    <div className="flex flex-col">
      <div className="flex space-x-2">
        <div className="w-6 h-8 bg-white lg:h-full"></div>
        <Logo className="text-white hover:text-violet-5 max-w-[82px] lg:max-w-[96px] mb-0.5 lg:mb-1" />
      </div>
      <div className="flex flex-col px-8 mt-6 text-sm font-medium text-white md:ml-8 md:px-0">
        <p>{t('well_being_footer')}</p>
        <p>{t('well_being_footer_1')}</p>
      </div>
    </div>
  )
}

export default FooterTopSection
